import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Stack } from '@mui/material';
import React from 'react';

import type { BoxItemProps } from '../BoxItem';
import BoxItem from '../BoxItem';
import BoxItemSkeleton from '../BoxItem/BoxItemSkeleton';
import { MobileBody } from '../Typography';

const DEFAULT_SKELETON_COUNT = 5;

export interface BoxItemStackProps {
  items: BoxItemProps[];
  loading?: boolean;
  skeletonCount?: number;
}

const BoxItemStack: React.FC<BoxItemStackProps> = ({
  items,
  loading = false,
  skeletonCount = DEFAULT_SKELETON_COUNT,
}) => {
  if (loading) {
    return (
      <Stack spacing={0} sx={{ width: '100%' }}>
        {Array.from({ length: skeletonCount }, (_, i) => (
          <BoxItemSkeleton key={`skeleton-${i}`} />
        ))}
      </Stack>
    );
  }

  const isEmpty = items.length === 0;

  if (isEmpty) {
    return (
      <Stack
        direction="column"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          minHeight: '200px',
          display: 'flex',
        }}
      >
        <SearchOffIcon
          sx={{
            color: 'text.secondary',
            fontSize: '2rem',
            textAlign: 'center',
          }}
        />
        <MobileBody color="text.secondary" sx={{ textAlign: 'center' }}>
          No se han encontrado resultados.
        </MobileBody>
      </Stack>
    );
  }

  return (
    <Stack spacing={0} sx={{ width: '100%' }}>
      {items.map((item, index) => (
        <BoxItem
          key={`${item.primaryText}-${index}`}
          primaryText={item.primaryText}
          amount={item.amount}
          secondaryText={item.secondaryText}
          chips={item.chips}
          onClick={item.onClick}
        />
      ))}
    </Stack>
  );
};

export default BoxItemStack;
